import React, { useState, useEffect } from "react";
import "../styles/Applicationformlist.css";
import API_BASE from "../apiConfig"; // <-- import from config

export default function Applicationformlist({ user }) {
  const [gnmApplications, setGnmApplications] = useState([]);
  const [paramedicalApplications, setParamedicalApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function fetchApplications() {
      setLoading(true);
      setError("");
      try {
        // Fetch GNM applications
        const gnmRes = await fetch(`${API_BASE}/api/gnm-applications`, { cache: "no-store" });
        // Fetch Paramedical applications
        const paraRes = await fetch(`${API_BASE}/api/paramedical-applications`, { cache: "no-store" });

        if (!gnmRes.ok) {
          throw new Error(`GNM API error: ${gnmRes.status} ${gnmRes.statusText}`);
        }
        if (!paraRes.ok) {
          throw new Error(`Paramedical API error: ${paraRes.status} ${paraRes.statusText}`);
        }

        let gnmJson = [];
        let paraJson = [];
        try {
          gnmJson = await gnmRes.json();
        } catch (e) {
          gnmJson = [];
        }
        try {
          paraJson = await paraRes.json();
        } catch (e) {
          paraJson = [];
        }

        setGnmApplications(Array.isArray(gnmJson) ? gnmJson : []);
        setParamedicalApplications(Array.isArray(paraJson) ? paraJson : []);
      } catch (err) {
        setError(
          err.message ||
          "Error loading applications. Possible network, SSL, or backend API issue."
        );
        setGnmApplications([]);
        setParamedicalApplications([]);
      }
      setLoading(false);
    }
    fetchApplications();
  }, []);

  return (
    <div className="application-list-wrapper">
      <h2>Student Application Forms</h2>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div className="error-message" style={{ color: "red", background: "#ffeaea", padding: "12px", marginTop: "8px", borderRadius: "6px" }}>
          {error}
        </div>
      ) : (
        <>
          <h3>GNM Applications</h3>
          <div className="table-container">
            <table className="application-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>DOB</th>
                  <th>Address</th>
                  <th>Qualification</th>
                  <th>Stream</th>
                  <th>Applied At</th>
                </tr>
              </thead>
              <tbody>
                {gnmApplications.length === 0 ? (
                  <tr>
                    <td colSpan={8}>No applications found.</td>
                  </tr>
                ) : (
                  gnmApplications.map((app, idx) => (
                    <tr key={app.id || idx}>
                      <td>{app.name}</td>
                      <td>{app.email}</td>
                      <td>{app.phone}</td>
                      <td>{app.dob}</td>
                      <td>{app.address}</td>
                      <td>{app.qualification}</td>
                      <td>{app.stream}</td>
                      <td>{app.applied_at}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <h3>Paramedical Applications</h3>
          <div className="table-container">
            <table className="application-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>DOB</th>
                  <th>Address</th>
                  <th>Qualification</th>
                  <th>Course</th>
                  <th>Applied At</th>
                </tr>
              </thead>
              <tbody>
                {paramedicalApplications.length === 0 ? (
                  <tr>
                    <td colSpan={8}>No applications found.</td>
                  </tr>
                ) : (
                  paramedicalApplications.map((app, idx) => (
                    <tr key={app.id || idx}>
                      <td>{app.name}</td>
                      <td>{app.email}</td>
                      <td>{app.phone}</td>
                      <td>{app.dob}</td>
                      <td>{app.address}</td>
                      <td>{app.qualification}</td>
                      <td>{app.paramedicalCourse || app.course}</td>
                      <td>{app.applied_at}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}